import { render } from "./edit_buyer.vue?vue&type=template&id=45d806c9"
import script from "./edit_buyer.vue?vue&type=script&lang=js"
export * from "./edit_buyer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__